/* Main Theme JavaScript */
/* This file contains global theme functionality */

document.addEventListener('DOMContentLoaded', function() {
  // Add your theme-specific JavaScript here
  console.log('Theme loaded successfully');
  
  // Monster Cart Integration - Global Cart Count Sync
  function updateGlobalCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update all cart count elements
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
          // Show/hide based on count
          if (cart.item_count === 0) {
            el.style.display = 'none';
          } else {
            el.style.display = 'flex';
          }
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
  
  // Listen for cart updates from Monster Cart
  document.addEventListener('cart:updated', updateGlobalCartCount);
  document.addEventListener('monsterCart:updated', updateGlobalCartCount);
  
  // Also listen for Shopify cart updates
  document.addEventListener('shopify:cart:updated', updateGlobalCartCount);
  
  // Poll for cart count updates (fallback for apps that don't dispatch events)
  let cartCountCheckInterval = setInterval(function() {
    const currentCount = document.querySelector('[data-cart-count]');
    if (currentCount) {
      const displayedCount = parseInt(currentCount.getAttribute('data-cart-count')) || 0;
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count !== displayedCount) {
            updateGlobalCartCount();
          }
        })
        .catch(() => {
          // Silently fail - cart might not be accessible
        });
    }
  }, 2000); // Check every 2 seconds
  
  // Clear interval when page unloads
  window.addEventListener('beforeunload', function() {
    if (cartCountCheckInterval) {
      clearInterval(cartCountCheckInterval);
    }
  });
  
  // Initial cart count update
  updateGlobalCartCount();
  
  // Monster Cart Diagnostic Helper (for debugging)
  window.checkMonsterCart = function() {
    console.log('=== Monster Cart Diagnostic ===');
    console.log('Checking for Monster Cart...');
    
    // Check window objects
    const monsterCartObjects = Object.keys(window).filter(k => 
      k.toLowerCase().includes('monster') || 
      k.toLowerCase().includes('cart') ||
      k.toLowerCase().includes('drawer')
    );
    console.log('Window objects with "monster", "cart", or "drawer":', monsterCartObjects);
    
    // Check for specific Monster Cart objects
    console.log('window.MonsterCart:', typeof window.MonsterCart);
    console.log('window.monsterCart:', typeof window.monsterCart);
    console.log('window.MonsterCartUpsell:', typeof window.MonsterCartUpsell);
    
    // Check for trigger elements
    const triggers = document.querySelectorAll('[data-monster-cart], [data-cart-drawer], [class*="monster"], [id*="monster"]');
    console.log('Found trigger elements:', triggers.length, triggers);
    
    // Check for cart drawer elements
    const drawers = document.querySelectorAll('[class*="drawer"], [data-drawer], [id*="drawer"]');
    console.log('Found drawer elements:', drawers.length);
    
    return {
      windowObjects: monsterCartObjects,
      hasMonsterCart: typeof window.MonsterCart !== 'undefined',
      hasMonsterCartLower: typeof window.monsterCart !== 'undefined',
      triggerElements: triggers.length,
      drawerElements: drawers.length
    };
  };
  
  // Auto-check after page load
  setTimeout(function() {
    if (window.checkMonsterCart) {
      window.checkMonsterCart();
    }
  }, 3000);
}); 